import "./src/styles/global.css"
import "./src/styles/custom.css"; 
/*  export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // Always scroll to the top on page navigation
  //console.log(location.action)
  //if (location.action === 'PUSH') {
    window.scrollTo(0, 0);
  //}

  return 
}
// gatsby-browser.js
export const onClientEntry = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
}; */

// Using ES6 export syntax for Gatsby's browser API hooks
/* export const onRouteUpdate = () => {
  // Function to set the cursor style for all elements
  function setCursorStyle(style) {
    const elements = document.querySelectorAll("*");
    elements.forEach(element => {
      element.style.cursor = style;
    });
  }

  // Check if the custom cursor element exists
  const cursor = document.getElementById("customCursor");
  if (cursor) {
    // Adjust the custom cursor position on mouse movement
    document.addEventListener("mousemove", e => {
      cursor.style.left = `${e.pageX}px`;
      cursor.style.top = `${e.pageY}px`;
    });

    // Add or remove 'active' class on links hover
    const links = document.querySelectorAll("a");
    links.forEach(link => {
      link.addEventListener("mouseenter", () => cursor.classList.add("active"));
      link.addEventListener("mouseleave", () => cursor.classList.remove("active"));
    });

    // Hide the default cursor
    setCursorStyle("none");
  }
}; */

// gatsby-browser.js

/* export const onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }
};

export const onInitialClientRender = () => {
  window.addEventListener('popstate', () => {
    window.scrollTo(0, 0);
  });
}; */



/* export const onRouteUpdate = ({ prevLocation }) => { // Check if this is not the initial page load
  if (prevLocation) { window.scrollTo(0, 0); } 
}; */

export const onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }
  wrapCodeElements();
};

export const onInitialClientRender = () => {
  window.addEventListener('popstate', () => {
    window.scrollTo(0, 0);
  });
};

const wrapCodeElements = () => {
  document.querySelectorAll("code").forEach((codeEl) => {
    if (!codeEl.parentElement.classList.contains("blog-code-block-parent")) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("blog-code-block-parent");

      codeEl.parentNode.insertBefore(wrapper, codeEl);
      wrapper.appendChild(codeEl);
    }
  });
};
 